<template>
  <StandardDialog @click-outside="$router.push({name: 'ProjectTaktPlan'})">
    <template #content>
      <router-view />
    </template>
  </StandardDialog>
</template>

<script>
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue'

export default {
  props: [],
  components: {
    StandardDialog
  },
  mixins: [],
  created(){
  },
  data: () => ({
  }),
}
</script>
<style scoped>

</style>
